import TooltipCustom from "@ui/tooltipCustom/TooltipCustom";
import {FormControlLabel, Switch} from "@mui/material";
import {SxType} from "@baseTypes/sx/sxTypes";
import {FC} from "react";

interface IProps{
    disabled?:boolean,
    checked?:boolean,
    onChange?:(checked:boolean)=>void,
    label?:string,
    labelPlacement?:"bottom" | "top" | "end" | "start",
    sx?:SxType,
    tooltip?:string,
    convertToBoolean?:boolean,
    size?:'small'
}

const SwitchCustom:FC<IProps> = ({
                          disabled,
                          checked,
                          onChange,
                          label,
                          labelPlacement,
                          sx,
                          tooltip,
                          convertToBoolean = false,
                                     size,
                      }) => {


    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const checked = convertToBoolean ? event.target.checked ? 1 : 0 : event.target.checked as boolean;
        if (onChange) {
            onChange(checked as boolean)
        }
    }

    if (tooltip) {
        return (
            <TooltipCustom
                title={tooltip}
            >
                <FormControlLabel
                    labelPlacement={labelPlacement}
                    disabled={disabled}
                    sx={sx}

                    control={<Switch
                        size={'small'}
                        checked={typeof  checked === "number" ? Boolean(Number(checked)) : checked}
                        onChange={handleChange}
                    />} label={label}/>

            </TooltipCustom>
        );
    }

    return (
       <span>
            <FormControlLabel
                labelPlacement={labelPlacement}
                disabled={disabled}
                sx={sx}
                control={<Switch
                    size={size}
                    checked={typeof  checked === "number" ? Boolean(Number(checked)) : checked}
                    onChange={handleChange}
                />} label={label}/>
       </span>
    );
};

export default SwitchCustom;